/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const SECTOR_ALLOCATION_URL = `${API_URL}/sectorAllocation`;
